<!-- <button (click)="sendMessage()">Click Me</button> -->

<div class="container">
    @for(team of teams; track team.id ){
       <app-score-board-card [team]="team"></app-score-board-card>
    } 
    
</div>
